/**
 * Adapts a browse product from the discover service response to the
 * plain object shape that ShopV2's ProductCard expects (snake_case fields
 * plus underscore-prefixed computed properties).
 */
const adaptProductForCard = (product) => ({
  product_id: product.productId,
  name: product.name,
  image_url: product.imageUrl,
  product_type: product.productType,
  aspect_ratio: product.aspectRatio,
  vaulted_until: product.vaultedUntil,
  signed_type: product.signedType,
  stock: product.stock,
  route: product.route,
  _variants: null,
  _priceRange: { min: product.priceCents, max: product.priceCents },
  _totalPrice: product.priceCents,
  _vaNames: product.fulfillers.map((f) => f.name),
  _isHolo: false,
});

export default adaptProductForCard;
